import { render, staticRenderFns } from "./DialogFotosAnterios.vue?vue&type=template&id=cbc63140"
import script from "./DialogFotosAnterios.vue?vue&type=script&lang=js"
export * from "./DialogFotosAnterios.vue?vue&type=script&lang=js"
import style0 from "./DialogFotosAnterios.vue?vue&type=style&index=0&id=cbc63140&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports